import { api, useCurrentUser } from '@cma/app'
import {
  DestroyPlatformClientContentsMutation,
  DestroyPlatformClientContentsMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useDestroyPlatformClientContents() {
  const queryClient = useQueryClient()
  const { data: { currentUser } = {} } = useCurrentUser()

  return useMutation<
    DestroyPlatformClientContentsMutation,
    Error,
    DestroyPlatformClientContentsMutationVariables
  >(
    (variables) => {
      const query = gql`
        mutation DestroyPlatformClientContents($ids: [ID!]!) {
          destroyPlatformClientContents(ids: $ids) {
            deletedIds
            errors
          }
        }
      `
      return api<
        DestroyPlatformClientContentsMutation,
        DestroyPlatformClientContentsMutationVariables
      >({ query, variables })
    },
    {
      async onSuccess() {
        await queryClient.invalidateQueries([
          'platformContent',
          { id: currentUser?.account?.id || '' }
        ])
      }
    }
  )
}
